(function () {
  if (window.__cpUkCollectionFilterInitialized) return;
  window.__cpUkCollectionFilterInitialized = true;

  var PRODUCT_SELECTOR = '.t4s-product';
  var SPICE_PRODUCT_SELECTOR = '.cp-spice-card';
  var CONTAINER_SELECTOR = '.t4s-main-collection-page .t4s-products';
  var SPICE_CONTAINER_SELECTOR = '.cp-spice-grid';
  var scheduled = false;
  var COLLECTION_ALLOWLISTS = {
    cleaning: {
      'crep-protect-power-tool-shoe-cleaner-ean': true,
      'crep-protect-gift-pack-ean': true,
      'crep-protect-cure-refill-ean': true,
      'crep-protect-foam-x-ean': true,
      'crep-protect-box-pack-ean': true,
      'crep-protect-cure-travel-kit-ean': true,
      'crep-protect-starter-pack-ean': true,
      'crep-protect-wipes-12-pack-ean': true,
      'crep-protect-foam-x-towel-bundle-ean': true,
      'crep-protect-cleaning-towel-ean': true
    },
    protection: {
      'crep-protect-spray-ean': true,
      'crep-protect-suede-reviver-ean': true,
      'crep-protect-eraser-ean': true,
      'crep-protect-mark-on-pen-ean': true,
      'crep-protect-pill-ean': true,
      'crep-protect-foam-mini-ean': true,
      'crep-protect-spray-4-pack-ean': true,
      'crep-protect-shoe-deoderiser-fresh-linen-ean': true,
      'crep-protect-suede-nubuck-pack-ean': true,
      'crep-protect-shoe-deoderiser-vanquish-ean': true,
      'crep-protect-footwear-deoderiser-bundle-ean': true
    },
    storage: {
      'crep-protect-shoe-storage-display-crate-v2-ean': true,
      'crep-protect-sneaker-crates-v3-ean': true
    }
  };

  function getCollectionHandle() {
    var match = window.location.pathname.match(/^\/collections\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getAllowedMap(collectionHandle) {
    return COLLECTION_ALLOWLISTS[collectionHandle] || null;
  }

  function parseOptions(card) {
    var source = card.matches('[data-product-options]') ? card : card.querySelector('[data-product-options]');
    if (!source) return null;

    var raw = source.getAttribute('data-product-options');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function parseSpiceCard(card) {
    var link = card.querySelector('.cp-spice-card__media-link, .cp-spice-card__title a');
    if (!link) return null;

    var href = link.getAttribute('href') || '';
    var handleMatch = href.match(/\/products\/([^\/?#]+)/i);
    if (!handleMatch) return null;

    var addButton = card.querySelector('.cp-spice-card__cta-side--add, .cp-spice-card__street-tech-add');
    var isDisabled = false;

    if (addButton) {
      isDisabled =
        addButton.classList.contains('is-disabled') ||
        addButton.getAttribute('aria-disabled') === 'true' ||
        /out of stock/i.test(addButton.textContent || '');
    }

    return {
      handle: decodeURIComponent(handleMatch[1]),
      available: !isDisabled
    };
  }

  function isAllowed(handle, available, collectionHandle) {
    if (!handle || !available) return false;

    var allowedMap = getAllowedMap(collectionHandle);
    if (allowedMap) {
      return !!allowedMap[handle];
    }

    return /-ean$/i.test(handle);
  }

  function ensureEmptyState(parent) {
    if (!parent) return null;

    var emptyState = parent.querySelector('.cp-uk-collection-empty');
    if (emptyState) return emptyState;

    emptyState = document.createElement('div');
    emptyState.className = 't4s-col-item t4s-col-12 cp-uk-collection-empty';
    emptyState.textContent = 'No active UK EAN products are currently available in this collection.';
    parent.appendChild(emptyState);
    return emptyState;
  }

  function filterCardsInContainer(container, selector, parseCard, collectionHandle, seen) {
    var cards = Array.prototype.slice.call(container.querySelectorAll(selector));
    if (!cards.length) return 0;

    var visibleCount = 0;

    cards.forEach(function (card) {
      var productData = parseCard(card);
      if (!productData || !productData.handle) {
        card.remove();
        return;
      }

      var handle = productData.handle;
      var allowed = isAllowed(handle, !!productData.available, collectionHandle) && !seen.has(handle);

      if (!allowed) {
        card.remove();
        return;
      }

      seen.add(handle);
      visibleCount += 1;
    });

    return visibleCount;
  }

  function filterCollectionCards() {
    scheduled = false;

    var collectionHandle = getCollectionHandle();
    if (!collectionHandle) return;

    var seen = new Set();
    var totalVisibleCount = 0;
    var lastParent = null;

    var t4sContainers = Array.prototype.slice.call(document.querySelectorAll(CONTAINER_SELECTOR));
    t4sContainers.forEach(function (container) {
      lastParent = container.parentElement || lastParent;
      totalVisibleCount += filterCardsInContainer(container, PRODUCT_SELECTOR, parseOptions, collectionHandle, seen);
    });

    var spiceContainers = Array.prototype.slice.call(document.querySelectorAll(SPICE_CONTAINER_SELECTOR));
    spiceContainers.forEach(function (container) {
      lastParent = container.parentElement || lastParent;
      totalVisibleCount += filterCardsInContainer(container, SPICE_PRODUCT_SELECTOR, parseSpiceCard, collectionHandle, seen);
    });

    if (!lastParent) return;

    var emptyState = lastParent.querySelector('.cp-uk-collection-empty');

    if (totalVisibleCount === 0) {
      ensureEmptyState(lastParent);
    } else if (emptyState) {
      emptyState.remove();
    }

    window.dispatchEvent(new Event('resize'));
  }

  function scheduleFilter() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(filterCollectionCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFilter, { once: true });
  } else {
    scheduleFilter();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (mutation.type !== 'childList') continue;
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        scheduleFilter();
        return;
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
